<template>
  <div class="special-sale-item">
    <slot name="filter"></slot>
    <div class="goods-list">
      <div :key="index" class="goods-details" v-for="(sku, index) in skuList">
        <a href="javascript:;">
          <div class="goods-img">
            <img alt v-lazy="sku.pic_url" />
          </div>
          <div class="goods-desc">
            <div class="goods-name van-ellipsis">{{sku.name}}</div>
            <div class="goods-price">市场价：¥{{sku.market_price}}</div>
            <div class="goods-check">
              <van-switch
                @click="change(sku.sku_id, sku.status)"
                active-color="#2ECC71"
                inactive-color="#BFBFBF"
                size="0.32rem"
                v-model="sku.status"
              ></van-switch>
              <span>加入信用购</span>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { Switch } from 'vant'
let flag = false
export default {
  name: 'productDoubleEach',
  components: {
    'van-switch': Switch
  },
  props: {
    skuList: {
      type: Array,
      require: true
    },
    gid: {
      type: [String, Number]
    }
  },

  methods: {
    change (id, status) {
      if (flag) {
        return false
      }
      flag = true
      this.$emit('change', { status, id })
      flag = false
    }
  }
}
</script>

<style lang="less" scoped>
.goods-list {
  padding: 0 0.2rem;
  .flex-between;
  .goods-details {
    margin-top: 0.2rem;
    width: 2.25rem;
    font-size: @fz22;
    border-radius: 5px;
    overflow: hidden;
    .goods-desc {
      padding: 0 0.1rem 0.12rem;
      background-color: #fff;
    }
    .goods-img {
      widows: 100%;
      height: 2.25rem;
    }
    .goods-name {
      padding: 0.15rem 0 0.1rem;
      color: @base;
    }
    .goods-price,
    .goods-check {
      color: #929292;
    }
    .goods-check {
      width: 100%;
      .flex-between;
      margin-top: 0.2rem;
    }
  }
}
</style>
